import React, { useState, useEffect } from "react"
import { Container, Modal, Row, Col } from 'react-bootstrap';
import GoogleRating from "../../googleRating/GoogleRating"
import { bounceInRight, bounceInLeft } from 'react-animations';
import AwardBanner from './AwardBanner'
import Radium, { StyleRoot } from 'radium';
import ScrollAnimation from 'react-animate-on-scroll';
import ReactPlayer from "react-player";
import "./Banner.scss"
import ReactMarkdown from "react-markdown"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import YearAwardImg from "../../../images/static/year_award.webp"
import { getSrc } from "gatsby-plugin-image"
// markup
import loadable from "@loadable/component";
import PropertyBanner from '@Components/MarketProperty/PropertyBanner/PropertyBanner'
import GetURL from '@Components/common/site/get-url';
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
import CustomVideoPlay from "./CustomVideo.js";
import SearchBlock from "../SearchBlock/SearchBlock.js";
import { Helmet } from "react-helmet";
import wordsToNumbers from 'words-to-numbers';
import { useLocation } from "@reach/router";
import { getitems } from "../../common/site/utils";
import ContactEnquiry from "@Components/forms/contact-enquiry";
import ImageRenderer from "../../ImageRenderer/ImageRenderer"
// import BookValuations from "@Components/forms/book-a-valuation";
const BookValuations = loadable(() => import("@Components/forms/book-a-valuation"))

const styles = {
  bounceInRight: {
    animation: 'x 2s',
    animationName: Radium.keyframes(bounceInRight, 'bounceInRight')
  },
  bounceInLeft: {
    animation: 'x 2s',
    animationName: Radium.keyframes(bounceInLeft, 'bounceInLeft')
  }
}
const Banner = (props) => {

  const [testimonials, setTestimonials] = React.useState([])
  const [showModal, setShowModal] = useState(false);
  let processedImages = JSON.stringify({});
  if (props?.imagetransforms?.Image_Transforms) {
    processedImages = props?.imagetransforms.Image_Transforms;
  }
  var settings = {
    dots: true,
    infinite: true,
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  };

  const location = useLocation();
  const thePath = location.pathname
  const [renderComponent, setRenderComponent] = useState(false);
  var callReviewApi = true;

  React.useEffect(() => {
    getReviews()
    // window.addEventListener("mousemove", () => {
    //   if (renderComponent === false) {
    //     setRenderComponent(true)
    //     getReviews()
    //   }
    // })
    // window.addEventListener("touchmove", () => {
    //   if (renderComponent === false) {
    //     setRenderComponent(true)
    //     getReviews()
    //   }
    // })
    // window.addEventListener("keypress", () => {
    //   if (renderComponent === false) {
    //     setRenderComponent(true)
    //     getReviews()
    //   }
    // })
    if (!renderComponent) {
      setRenderComponent(true)
    }
  }, [])

  function getReviews() {
    if (callReviewApi == true) {
      let url = `${process.env.GATSBY_STRAPI_SRC}/stb-google-reviews/google-review-reviews`
      getitems({ url: url, setTestimonials: setTestimonials });
      callReviewApi = false
    }
  }
  var testimonial_count = testimonials ? testimonials.length : 0;
  var rating_count = 0;
  testimonials && testimonials.length > 0 && testimonials.map((item, ind) => {
    rating_count += parseInt(wordsToNumbers(item.starRating));
  })
  var rating_avg = rating_count / testimonial_count;
  var schemarating = parseFloat(rating_avg.toFixed(1))

  return (
    <>

      {props.Pagename === "Home" && props?.page && testimonial_count > 0 &&
        <Helmet>
          <script type="application/ld+json">{`
                                {
                                    "@context": "http://schema.org",
                                    "@type": "Organization",
                                    "url": "https://www.bentleyhurst.co.uk/", 
                                    "name": "${props?.page?.Meta_Title}", 
                                    "description": "${props?.page?.Meta_Description}",   
                                    "alternateName": "Bentley Hurst", 
                                    "logo": "https://www.bentleyhurst.co.uk/images/mail-logo.png", 
                                    "aggregateRating": { 
                                        "@type": "AggregateRating", 
                                        "ratingValue": "${schemarating}", 
                                        "reviewCount": "${testimonial_count}" 
                                    }, 
                                     "sameAs": [ 
                                        "https://www.facebook.com/BentleyHurstLTD", 
                                        "https://www.instagram.com/bentley.hurst/", 
                                        "https://twitter.com/bentley_hurst", 
                                        "https://www.youtube.com/channel/UCbok1WpAXT-I1586sYJRXbw", 
                                        "https://www.linkedin.com/company/bentley-hurst" 
                                    ] 
                                }
                            `}
          </script>
          
        </Helmet>

      }


      <React.Fragment>
        {props.Pagename === 'Market' ? <PropertyBanner Video_Ask={props.Video_Ask} Title={props.Title}
          Banner_Content={props.Banner_Content} Banner_CTA_1_Label={props.Banner_CTA_1_Label} Banner_CTA_1_URL={props.Banner_CTA_1_URL} Banner_CTA_2_Label={props.Banner_CTA_2_Label} Banner_CTA_2_URL={props.Banner_CTA_2_URL} Banner_Image={props.Banner_Image} Right_Video_Image={props.Right_Video_Image} Embed_Video_URL={props.Embed_Video_URL} Show_Review={props.Show_Review} Show_Search={props.Show_Search} testimonials={testimonials}
        /> :
          <>
            {props.Slide ?
              <Slider {...settings}>
                {props.Slider.map((item, i) => (

                  <div className="main-banner">
                    <div className="main-banner-embed">
                      <img src={getSrc(item.Slider_Image.url_sharp)} alt={item.Slider_Image.alternativeText} />
                    </div>
                    <div className="main-banner-content">
                      <Container>
                        <div className="banner-text">

                          <div className="banner-heading-second">{item.Title}</div>

                          <StyleRoot>
                            <div className="rich-text-editer-block">
                              <ReactMarkdown style={styles.bounceInLeft} source={item.Banner_Content} allowDangerousHtml />
                            </div>
                          </StyleRoot>

                          <StyleRoot>
                            <div className="btn-wrap" style={styles.bounceInRight}>
                              {item.Banner_CTA_1_Label !== null && item.Banner_CTA_1_URL !== null &&
                                <GetURL label={item.Banner_CTA_1_Label} alias={item.Banner_CTA_1_URL?.Alias} class={thePath == '/' ? 'glow-on-hover' : 'btn btn-primary'} />

                              }
                              {item.Banner_CTA_2_Label !== null && item.Banner_CTA_2_URL !== null &&
                                <GetURL label={item.Banner_CTA_2_Label} alias={item.Banner_CTA_2_URL?.Alias} class="btn btn-primary" />
                              }
                              {item.Banner_CTA_2_Label === 'Send Us Your CV' ? <a onClick={item.executeScroll} className="btn btn-primary">{item.Banner_CTA_2_Label}</a> : ''}
                            </div>
                          </StyleRoot>

                        </div>

                        {item.Show_Review ?
                          <StyleRoot>
                            <div style={styles.bounceInLeft} className="rating-block d-none d-lg-block">
                              <GoogleRating testimonials={testimonials} />
                            </div>
                          </StyleRoot>
                          : null}

                        {/* <StyleRoot>
                            <div class="row">
                              <div class="col-12 col-md-5" id="award-banner-div"><AwardBanner/></div>
                              <div class="col-12 col-md-5" id="year_award_logo">
                                <img src={YearAwardImg} alt="British Property Award 2023 Gold Winner for the Best Estate Agents in Manchester" />
                              </div>
                            </div>
                          </StyleRoot> */}
                      </Container>
                    </div>


                  </div>))}
              </Slider>
              :
              <div className="main-banner">
                <div className="main-banner-embed">
                  {props.areaGuide ?
                    <ImageRenderer ImageSrc={props?.Banner_Image} altText={props.Banner_Image?.alternativeText + ' - Bentley Hurst'} ggfx_results={props.ggfx_results} strapi_id={props?.id} imagename="area-guide.Banner_Image.details" />
                    :
                    <img src={props.Banner_Image?.url_sharp ? getSrc(props.Banner_Image?.url_sharp) : props?.Banner_Image?.url} alt={props.Banner_Image?.alternativeText} />
                  }
                  {/* <img src={props.Banner_Image?.url_sharp ? getSrc(props.Banner_Image?.url_sharp) : props?.Banner_Image?.url} alt={props.Banner_Image?.alternativeText} /> */}

                  {/* <ImageRenderer ImageSrc={props.Banner_Image} altText={props.Banner_Image?.alternativeText + ' - Bentley Hurst'} ggfx_results={props.ggfx_results} strapi_id={props?.id} imagename="articles.images.full_banner" renderer="pic-src" /> */}
                </div>
                {props.Video_URL &&
                  <div className="main-banner-video">
                    <ReactPlayer
                      url={props.Video_URL.url}
                      muted={true}
                      loop={true}
                      controls={false}
                      autoplay={true}
                      playsinline={true}
                      playing={true}
                      width={"100%"}
                      height={"100%"}
                    />
                  </div>
                }
                <div className="main-banner-content">
                  {props.Embed_Video_URL && !props.areaGuide ?
                    <CustomVideoPlay title={props.Title} url={props.Embed_Video_URL} />
                    : ''}
                  <Container>
                    <div className="banner-text">

                 
                
                    {thePath === '/'? <p className="heading1">{props.Title}</p> :
                       <h1>{props.Title}</h1> }

                      <StyleRoot>
                        <div className="rich-text-editer-block">
                          <ReactMarkdown style={styles.bounceInLeft} source={props.Banner_Content} allowDangerousHtml />
                        </div>
                      </StyleRoot>
                      {(props.Banner_CTA_1_Label || props.Banner_CTA_2_Label) && thePath !== '/' &&
                        <div className="btn-wrap" style={styles.bounceInRight}>
                          {props.Banner_CTA_1_Label !== null && props.Banner_CTA_1_URL !== null && 
                            <GetURL label={props.Banner_CTA_1_Label} alias={props.Banner_CTA_1_URL?.Alias} class={thePath == '/' ? 'glow-on-hover testt' : 'btn btn-primary'} />
                          }
                          {props.Banner_CTA_2_Label !== null && props.Banner_CTA_2_URL !== null &&
                            <GetURL label={props.Banner_CTA_2_Label} alias={props.Banner_CTA_2_URL?.Alias} class="btn btn-primary" />
                          }
                          {props.Banner_CTA_2_Label !== null && props.Banner_CTA_2_URL === null && props.Banner_CTA2_Hash === 'contact-enquiry-modal' &&
                            <button className="btn btn-primary" onClick={() => setShowModal(true)}>{props.Banner_CTA_2_Label}</button>
                          }
                          {props.Banner_CTA_2_Label === 'Send Us Your CV' ? <a onClick={props.executeScroll} className="btn btn-primary">{props.Banner_CTA_2_Label}</a> : ''}
                        </div>
                      }
                    </div>
                    {
                      props.Show_Search &&
                      <SearchBlock />
                    }
                    {props.Show_Form &&
                      <Row className="justify-content-center">
                        <Col lg="8">
                          <BookValuations />
                        </Col>
                      </Row>

                    }
                    
                    {props.Show_Review ?
                      <StyleRoot>
                        <div style={styles.bounceInLeft} className={`rating-block d-flex ${props.areaGuide ? "justify-content-start" : ""}`}>
                          <GoogleRating testimonials={testimonials} />
                        </div>
                      </StyleRoot>
                      : null}

                      {(props.Banner_CTA_1_Label || props.Banner_CTA_2_Label) && thePath === '/' &&
                      <div className="btn-wrap" style={styles.bounceInRight}>
                        {props.Banner_CTA_1_Label !== null && props.Banner_CTA_1_URL !== null &&
                          <GetURL label={props.Banner_CTA_1_Label} alias={props.Banner_CTA_1_URL?.Alias} class={'glow-on-hover'} />
                        }
                      </div>
                    }

                    {/* {thePath.indexOf("/about-us/") >= 0 || thePath.indexOf("/careers/") >= 0 ?
                    <StyleRoot>
                      <div class="row">
                        <div class="col-12 col-md-5" id="award-banner-div"><AwardBanner /></div>
                      </div>
                    </StyleRoot> : null
                  } */}
                  </Container>
                </div>


              </div>
            }
          </>
        }
        <Modal show={showModal} centered onHide={() => setShowModal(false)} dialogClassName="modal-90w modal-form contact-us-modal-form" aria-labelledby="contact-us-modal">
          <Modal.Header closeButton className="contact-modal-header">
            <Modal.Title><h6>Contact Details</h6></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-section">
              <ContactEnquiry />
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </>
  )
}

export default Banner
